const { getWindow } = require('./index')

function getCookie(name) {
  const win = getWindow()
  if (win?.document) {
    const matches = win.document.cookie.match(new RegExp(
      `(?:^|; )${  name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')  }=([^;]*)`
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
  }
  return false
}

module.exports = { getCookie }